/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React STREAM
 * https://github.com/facebook/react-native
 *
 */
import type { Props } from './../types/types';

import React from 'react';
import { View } from './../libs/WebComponents';
const TouchableOpacity = (props: Props) => {
   if (!props) props = {};
   props = {
      className: props.onPress ? 'touchable-highlight' : 'touchable disabled',
      children: null,
      onPressIn: () => {},
      onPressOut: () => {},
      onPress: () => {},
      onMouseEnter: () => {},
      onMouseOut: () => {},
      onMouseLeave: () => {},
      onMouseMove: () => {},

      style: {},
      activeOpacity: 0.4,
      ...props
   };

   const [state, setState] = React.useState({ pressed: false });

   if (!props.onPress) {
      return (
         <View style={props.style} className={props.className}>
            {props.children}
         </View>
      );
   } else {
      const onPress = (e: any) => {
         setState({ pressed: false });
         props.onPress(e);
      };
      const onPressIn = (e: any) => {
         setState({ pressed: true });
         props.onPressIn(e);
      };

      const onPressOut = (e: any) => {
         setState({ pressed: false });
         props.onPressOut(e);
      };

      props.style = { ...props.style, cursor: 'pointer' };
      if (state.pressed) props.style = { ...props.style, opacity: props.activeOpacity };

      return (
         <div
            className={props.className}
            style={props.style}
            onMouseDown={(e) => onPressIn(e)}
            onMouseUp={(e) => onPressOut(e)}
            onMouseLeave={(e) => {
               props.onMouseLeave(e);
               onPressOut(e);
            }}
            onClick={(e) => onPress(e)}
            onMouseEnter={props.onMouseEnter}
            onMouseOut={props.onMouseOut}
            onMouseMove={props.onMouseMove}
         >
            {props.children}
         </div>
      );
   }
};

export default React.memo(TouchableOpacity);
